import { render, staticRenderFns } from "./PortfolioScene.vue?vue&type=template&id=4bc64cf3"
import script from "./PortfolioScene.vue?vue&type=script&lang=js"
export * from "./PortfolioScene.vue?vue&type=script&lang=js"
import style0 from "./PortfolioScene.vue?vue&type=style&index=0&id=4bc64cf3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports